import React from "react";
import { string } from "prop-types";
import Typography from "@components/shared/Typography";

const Address = ({ address1, address2, city, country, zipcode }) => (
  <div>
    <Typography data-id="address1">{address1}</Typography>
    {address2 && <Typography data-id="address2">{address2}</Typography>}
    <Typography data-id="zipcode-city">{`${zipcode} ${city}`}</Typography>
    <Typography data-id="country">{country}</Typography>
  </div>
);

Address.propTypes = {
  address1: string.isRequired,
  address2: string,
  city: string.isRequired,
  country: string.isRequired,
  zipcode: string.isRequired,
};

export default Address;
